/* ============================================================
   OS9 FINDER — Squiche HD file browser
   squiche.com
   ============================================================ */

(function () {
  'use strict';

  /* ── SQUICHE HD CONTENTS ────────────────────────────────────
     Edit this array to add/remove/reorder items in Squiche HD.
     kind: 'folder' | 'app' | 'file'
     action: 'collection' | 'snake' | 'weedcalc' | 'memes' | 'browser'
  ─────────────────────────────────────────────────────────── */
  const SQUICHE_HD_ITEMS = [
    {
      id: 'tees',
      label: 'Tee Shirt Designs',
      kind: 'folder',
      action: 'collection',
      handle: 'squiche-tees',
      title: 'Tee Shirt Designs',
      icon: 'folder',
    },
    {
      id: 'art-prints',
      label: 'Art Prints',
      kind: 'folder',
      action: 'collection',
      handle: 'squiche-art-prints',
      title: 'Art Prints',
      icon: 'folder',
    },
    {
      id: 'games',
      label: 'Games',
      kind: 'folder',
      action: 'games',
      icon: 'folder',
    },
  ];

  const GAMES_ITEMS = [
    {
      id: 'game-snake',
      label: 'Snake.app',
      kind: 'app',
      action: 'snake',
      icon: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/SNAKEICON.png?v=1777532861',
      iconFallback: '🐍',
    },
    {
      id: 'game-sniper',
      label: 'Sniper Assassin',
      kind: 'app',
      action: 'sniper',
      icon: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/SNIPER_ASSASIN_LOGO.png?v=1778486243',
      iconFallback: '🎯',
    },
    {
      id: 'game-minesweeper',
      label: 'Minesweeper',
      kind: 'app',
      action: 'minesweeper',
      icon: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/Microsoft_Minesweeper__281990_29.webp?v=1778493857',
      iconFallback: '💣',
    },
    /*
     * Flash games — upload .swf + icon to Shopify Files and paste the CDN URLs below.
     * aspect = width/height ratio of the game canvas (affects window sizing).
     * These use openFlashGame() in os9-apps.js via action: 'flash'.
     */
    {
      id: 'game-kitten-cannon',
      label: 'Kitten Cannon',
      kind: 'app',
      action: 'flash',
      swfUrl: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/kittencannon.swf?v=1778643572',
      aspect: 4 / 3,
      icon: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/KittenCannonLogo.png?v=1778657971',
      iconFallback: '🐱',
    },
    {
      id: 'game-xiaoxiao',
      label: 'XiaoXiao',
      kind: 'app',
      action: 'flash',
      swfUrl: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/XiaoXiao.swf?v=1778818159',
      aspect: 4 / 3,
      icon: '',   /* ← paste Shopify CDN URL of icon image here */
      iconFallback: '🥷',
    },
    {
      id: 'game-line-rider',
      label: 'Line Rider',
      kind: 'app',
      action: 'flash',
      swfUrl: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/Line_Rider_2.swf?v=1779611900',
      aspect: 4 / 3,
      icon: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/LineRiderIcon.png?v=1779611952',
      iconFallback: '🛷',
    },
    {
      id: 'game-impossible-quiz',
      label: 'Impossible Quiz',
      kind: 'app',
      action: 'flash',
      swfUrl: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/Impossible_Quiz_Deluxe_NG..swf?v=1779612008',
      aspect: 4 / 3,
      icon: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/ImpossibleQuiz.png?v=1779612024',
      iconFallback: '❓',
    },
    {
      id: 'app-emulator',
      label: 'Game Boy Player',
      kind: 'app',
      action: 'emulator',
      icon: 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/GBA_Icon_1870221a-958d-48c9-a58c-dc5282794156.png?v=1779045991',
      iconFallback: '🎮',
    },
  ];

  /* ── CSS ────────────────────────────────────────────────── */
  const CSS = `
    .finder-win .os9-win__scroll { background: var(--os9-white); }

    /* ── Icon view ── */
    .finder-icon-grid {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      gap: 8px;
      padding: 12px;
      min-height: 100%;
      background: var(--os9-white);
      user-select: none;
    }

    .finder-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      width: 72px;
      padding: 6px 4px;
      border-radius: 2px;
      cursor: default;
      position: relative;
    }

    .finder-item:hover { background: rgba(0,0,128,0.08); }

    .finder-item.is-selected {
      background: var(--os9-select);
    }

    .finder-item.is-selected .finder-item__label {
      background: var(--os9-select);
      color: var(--os9-white);
    }

    .finder-item__icon {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 36px;
      line-height: 1;
      flex-shrink: 0;
    }

    .finder-item__icon img {
      width: 48px;
      height: 48px;
      object-fit: cover;
      image-rendering: pixelated;
    }

    .finder-item__label {
      font-family: var(--os9-font-body);
      font-size: var(--os9-size-ui);
      color: var(--os9-black);
      text-align: center;
      line-height: 1.2;
      max-width: 70px;
      word-break: break-word;
      padding: 1px 3px;
    }

    /* ── List view ── */
    .finder-list {
      width: 100%;
      background: var(--os9-white);
      user-select: none;
      display: flex;
      flex-direction: column;
    }

    /* ── Column headers — kit: Atom / Column list header ──
       Flat fills, no gradient. The sorted column reads as pressed in. */
    .finder-list-header {
      display: flex;
      align-items: stretch;
      height: var(--os9-hdr-h);
      background: var(--os9-gray-400);
      font-family: var(--os9-font-body);
      font-size: var(--os9-size-body);
      color: var(--os9-black);
      position: sticky;
      top: 0;
      z-index: 2;
    }

    .finder-list-hcell {
      display: flex;
      align-items: center;
      padding: 4px 8px;
      background: var(--os9-gray-400);
      border: var(--os9-border-grid);
      box-shadow: var(--os9-bevel-raised);
      cursor: default;
      white-space: nowrap;
      font-weight: normal;
      overflow: hidden;
    }
    /* Sorted column: darker fill + pressed bevel. The kit does NOT bold it. */
    .finder-list-hcell.is-active {
      background: var(--os9-gray-600);
      box-shadow: var(--os9-bevel-sunken);
    }
    .finder-list-hcell:hover:not(.is-active) { background: var(--os9-gray-300); }

    .finder-list-hcell .sort-arrow { margin-left: 4px; font-size: 8px; }

    .finder-lh-chev { width: var(--os9-chevron); flex-shrink: 0; padding: 0; }

    /* Column widths — kit: Name 208 / Date 162 / Size 57 / Kind flex.
       Name is flexed rather than fixed so the window stays resizable. */
    .finder-lh-name     { flex: 1; min-width: 0; }
    .finder-lh-size     { width: var(--os9-col-size); flex-shrink: 0; justify-content: flex-end; }
    .finder-lh-kind     { width: 110px; flex-shrink: 0; }

    /* ── Rows — kit: 32px tall, 2px apart, banded by COLUMN not by row ── */
    .finder-list-body {
      display: flex;
      flex-direction: column;
      gap: var(--os9-row-gap);
      padding-top: var(--os9-row-gap);
    }

    .finder-list-row {
      display: flex;
      align-items: center;
      height: var(--os9-row-h);
      font-family: var(--os9-font-body);
      font-size: var(--os9-size-body);
      color: var(--os9-black);
      cursor: default;
    }

    /* Column banding: name cell one step darker than the data cells. */
    .finder-lr-chev,
    .finder-lr-icon,
    .finder-lr-name  { background: var(--os9-gray-300); }
    .finder-lr-size,
    .finder-lr-kind,
    .finder-lr-date,
    .finder-lr-pad   { background: var(--os9-gray-200); }

    .finder-list-row:hover .finder-lr-chev,
    .finder-list-row:hover .finder-lr-icon,
    .finder-list-row:hover .finder-lr-name,
    .finder-list-row:hover .finder-lr-size,
    .finder-list-row:hover .finder-lr-kind,
    .finder-list-row:hover .finder-lr-date,
    .finder-list-row:hover .finder-lr-pad { background: var(--os9-select-hover); }

    .finder-list-row.is-selected .finder-lr-chev,
    .finder-list-row.is-selected .finder-lr-icon,
    .finder-list-row.is-selected .finder-lr-name,
    .finder-list-row.is-selected .finder-lr-size,
    .finder-list-row.is-selected .finder-lr-kind,
    .finder-list-row.is-selected .finder-lr-date,
    .finder-list-row.is-selected .finder-lr-pad {
      background: var(--os9-select);
      color: var(--os9-select-text);
      opacity: 1;
    }

    /* Disclosure chevron — the kit draws a pixel triangle in lavender.
       Rotates a quarter turn when its folder is open. */
    .finder-lr-chev {
      width: var(--os9-chevron);
      height: 100%;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--os9-gray-300);
    }
    .finder-lr-chev.is-folder::before {
      content: "";
      width: 0; height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-left: 6px solid var(--os9-azul-light);
    }
    .finder-list-row.is-open .finder-lr-chev.is-folder::before { transform: rotate(90deg); }

    /* Row cells */
    .finder-lr-icon  {
      width: calc(var(--os9-row-icon) + 8px); height: 100%;
      flex-shrink: 0; display: flex; align-items: center; justify-content: center;
    }
    .finder-lr-icon img {
      width: var(--os9-row-icon); height: var(--os9-row-icon);
      image-rendering: pixelated; display: block;
    }
    .finder-lr-name  {
      flex: 1; min-width: 0; height: 100%;
      display: flex; align-items: center; gap: 4px;
      overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
      padding-right: 6px;
    }
    .finder-lr-size  {
      width: var(--os9-col-size); flex-shrink: 0; height: 100%;
      display: flex; align-items: center; justify-content: flex-end;
      padding: 0 8px; text-align: right;
    }
    .finder-lr-kind  {
      width: 110px; flex-shrink: 0; height: 100%;
      display: flex; align-items: center; padding-left: 8px;
    }
    .finder-lr-pad   { width: var(--os9-scroll-w); flex-shrink: 0; height: 100%; }

    /* ── Context menu ── */
    .finder-ctx-menu {
      position: fixed;
      background: var(--os9-gray-100);
      border: 1px solid var(--os9-gray-700);
      box-shadow: 2px 2px 0 rgba(0,0,0,0.35);
      z-index: 99999;
      min-width: 160px;
      padding: 3px 0;
      font-family: var(--os9-font-body);
      font-size: var(--os9-size-title);
    }

    .finder-ctx-item {
      display: block;
      padding: 4px 20px 4px 12px;
      cursor: default;
      color: var(--os9-black);
      white-space: nowrap;
    }

    .finder-ctx-item:hover {
      background: var(--os9-select);
      color: var(--os9-white);
    }

    .finder-ctx-item.is-checked::before {
      content: '✓ ';
      font-size: var(--os9-size-body);
    }

    .finder-ctx-sep {
      height: 1px;
      background: var(--os9-gray-500);
      border-bottom: 1px solid var(--os9-white);
      margin: 3px 0;
    }

    .finder-ctx-label {
      display: block;
      padding: 2px 12px;
      font-size: var(--os9-size-body);
      color: var(--os9-gray-600);
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    /* ── Meme grid ── */
    .finder-meme-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 12px;
      background: var(--os9-white);
    }

    .finder-meme-item {
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      cursor: default;
      padding: 4px;
      border-radius: 2px;
    }

    .finder-meme-item:hover { background: rgba(0,0,128,0.08); }
    .finder-meme-item.is-selected { background: rgba(0,0,128,0.15); }

    .finder-meme-item img {
      width: 72px;
      height: 72px;
      object-fit: cover;
      border: 1px solid var(--os9-gray-400);
      display: block;
    }

    .finder-meme-item__label {
      font-family: var(--os9-font-body);
      font-size: var(--os9-size-body);
      text-align: center;
      max-width: 76px;
      word-break: break-word;
      line-height: 1.2;
    }
  `;

  function injectCSS() {
    if (document.getElementById('os9-finder-css')) return;
    const s = document.createElement('style');
    s.id = 'os9-finder-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ── State ── */
  /* List is the default view: it carries the kit's Folder list rules —
     column headers, banded rows, disclosure chevrons — so it reads as OS9
     in a way the icon grid cannot. Icons stay available from the
     right-click menu, and whichever the visitor picks is remembered. */
  const VIEW_KEY = 'os9:finder:view';
  const SORT_KEY = 'os9:finder:sort';
  function readPref(key, allowed, fallback) {
    try {
      const v = window.localStorage.getItem(key);
      return allowed.indexOf(v) !== -1 ? v : fallback;
    } catch (e) { return fallback; }   /* private mode, blocked storage */
  }
  function writePref(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  let currentView = readPref(VIEW_KEY, ['icon', 'list'], 'list');
  let currentSort = readPref(SORT_KEY, ['name', 'date', 'size', 'kind'], 'kind');
  let selectedId = null;
  let ctxMenu = null;

  /* ── Sort items ── */
  function sortItems(items) {
    return [...items].sort((a, b) => {
      // Folders always float above apps/files regardless of sort column
      if (a.kind !== b.kind) return a.kind === 'folder' ? -1 : 1;
      if (currentSort === 'name') return a.label.localeCompare(b.label);
      if (currentSort === 'date') {
        var da = a.date || 0, db = b.date || 0;
        return db - da; // newest first
      }
      if (currentSort === 'size') {
        var sa = a.size || 0, sb = b.size || 0;
        return sb - sa; // largest first
      }
      // 'kind' — sort by kind label then name
      var ka = a.kind === 'folder' ? 'folder' : 'application program';
      var kb = b.kind === 'folder' ? 'folder' : 'application program';
      if (ka !== kb) return ka.localeCompare(kb);
      return a.label.localeCompare(b.label);
    });
  }

  /* ── Remove context menu ── */
  function removeCtxMenu() {
    if (ctxMenu) { ctxMenu.remove(); ctxMenu = null; }
  }

  /* ── Build context menu ── */
  function showCtxMenu(x, y, onViewChange, onSortChange) {
    removeCtxMenu();
    const menu = document.createElement('div');
    menu.className = 'finder-ctx-menu';
    menu.style.left = x + 'px';
    menu.style.top = y + 'px';

    menu.innerHTML = `
      <span class="finder-ctx-label">View</span>
      <div class="finder-ctx-item ${currentView === 'icon' ? 'is-checked' : ''}" data-action="view-icon">as Icons</div>
      <div class="finder-ctx-item ${currentView === 'list' ? 'is-checked' : ''}" data-action="view-list">as List</div>
      <div class="finder-ctx-sep"></div>
      <span class="finder-ctx-label">Sort by</span>
      <div class="finder-ctx-item ${currentSort === 'name' ? 'is-checked' : ''}" data-action="sort-name">Name</div>
      <div class="finder-ctx-item ${currentSort === 'date' ? 'is-checked' : ''}" data-action="sort-date">Date Modified</div>
      <div class="finder-ctx-item ${currentSort === 'size' ? 'is-checked' : ''}" data-action="sort-size">Size</div>
      <div class="finder-ctx-item ${currentSort === 'kind' ? 'is-checked' : ''}" data-action="sort-kind">Kind</div>
    `;

    menu.addEventListener('click', e => {
      const item = e.target.closest('[data-action]');
      if (!item) return;
      const action = item.dataset.action;
      if (action === 'view-icon') { currentView = 'icon'; writePref(VIEW_KEY, 'icon'); onViewChange(); }
      if (action === 'view-list') { currentView = 'list'; writePref(VIEW_KEY, 'list'); onViewChange(); }
      if (action === 'sort-name') { currentSort = 'name'; writePref(SORT_KEY, 'name'); onSortChange(); }
      if (action === 'sort-date') { currentSort = 'date'; writePref(SORT_KEY, 'date'); onSortChange(); }
      if (action === 'sort-size') { currentSort = 'size'; writePref(SORT_KEY, 'size'); onSortChange(); }
      if (action === 'sort-kind') { currentSort = 'kind'; writePref(SORT_KEY, 'kind'); onSortChange(); }
      removeCtxMenu();
    });

    document.body.appendChild(menu);
    ctxMenu = menu;

    // Auto-position if off screen
    const rect = menu.getBoundingClientRect();
    if (rect.right > window.innerWidth) menu.style.left = (x - rect.width) + 'px';
    if (rect.bottom > window.innerHeight) menu.style.top = (y - rect.height) + 'px';

    setTimeout(() => {
      document.addEventListener('click', removeCtxMenu, { once: true });
    }, 0);
  }

  /* ── Icons ── */
  const FOLDER_ICON_URL = 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/24.png?v=1777485957';

  function folderIcon(size) {
    size = size || 48;
    return `<img src="${FOLDER_ICON_URL}" alt="folder" style="width:${size}px;height:${size}px;image-rendering:pixelated;display:block;filter:drop-shadow(1px 2px 2px rgba(0,0,0,0.3));">`;
  }

  function appIcon(item, size) {
    size = size || 48;
    if (item.icon && item.icon.startsWith('http')) {
      return `<img src="${item.icon}" alt="${item.label}"
        style="width:${size}px;height:${size}px;image-rendering:pixelated;display:block;filter:drop-shadow(1px 2px 2px rgba(0,0,0,0.3));"
        onerror="this.outerHTML='<div style=\'width:${size}px;height:${size}px;display:flex;align-items:center;justify-content:center;font-size:${Math.round(size*0.65)}px;background:var(--os9-gray-300);border:1px solid var(--os9-gray-600);border-radius:4px;\'>${item.iconFallback || ''}</div>'">`;
    }
    return `<div style="width:${size}px;height:${size}px;display:flex;align-items:center;justify-content:center;font-size:${Math.round(size*0.65)}px;background:var(--os9-gray-300);border:1px solid var(--os9-gray-600);border-radius:4px;">${item.iconFallback || item.icon}</div>`;
  }

  /* ── Render icon view ── */
  function renderIconView(items, container, onOpen) {
    const sorted = sortItems(items);
    container.innerHTML = '';
    const grid = document.createElement('div');
    grid.className = 'finder-icon-grid';

    sorted.forEach(item => {
      const el = document.createElement('div');
      el.className = 'finder-item';
      el.dataset.itemId = item.id;
      if (item.disabled) {
        el.style.opacity = '0.45';
        el.style.cursor = 'not-allowed';
      }

      const iconHTML = item.kind === 'folder'
        ? `<div class="finder-item__icon">${folderIcon(48)}</div>`
        : `<div class="finder-item__icon">${appIcon(item, 48)}</div>`;

      const labelContent = item.disabled
        ? `${item.label}<br><span style="font-size:var(--os9-size-tiny);">Coming Soon</span>`
        : item.label;

      el.innerHTML = iconHTML + `<div class="finder-item__label">${labelContent}</div>`;
      grid.appendChild(el);
    });

    // Selection + double-click
    const lastTap = {};
    grid.addEventListener('click', e => {
      const item = e.target.closest('.finder-item');
      grid.querySelectorAll('.finder-item').forEach(i => i.classList.remove('is-selected'));
      if (item) { item.classList.add('is-selected'); selectedId = item.dataset.itemId; }
      else selectedId = null;
    });

    grid.addEventListener('dblclick', e => {
      const item = e.target.closest('.finder-item');
      if (!item) return;
      const data = items.find(i => i.id === item.dataset.itemId);
      if (data) onOpen(data);
    });

    grid.addEventListener('touchend', e => {
      const item = e.target.closest('.finder-item');
      if (!item) return;
      e.preventDefault();
      const data = items.find(i => i.id === item.dataset.itemId);
      if (data) onOpen(data);
    });

    container.appendChild(grid);
    return grid;
  }

  /* ── Render list view — OS9 Finder-accurate layout ── */
  function renderListView(items, container, onOpen) {
    container.innerHTML = '';
    const list = document.createElement('div');
    list.className = 'finder-list';

    /* ── Column header ── */
    function makeHeader(rerender) {
      const cols = [
        { key: null,   label: '',     cls: 'finder-lh-chev' },
        { key: 'name', label: 'Name', cls: 'finder-lh-name' },
        { key: 'size', label: 'Size', cls: 'finder-lh-size' },
        { key: 'kind', label: 'Kind', cls: 'finder-lh-kind' },
      ];
      const header = document.createElement('div');
      header.className = 'finder-list-header';
      cols.forEach(function (col) {
        const cell = document.createElement('div');
        cell.className = 'finder-list-hcell ' + col.cls;
        if (col.key && col.key === currentSort) cell.classList.add('is-active');
        cell.innerHTML = col.label + (col.key && col.key === currentSort ? '<span class="sort-arrow">&#9660;</span>' : '');
        if (col.key) {
          cell.addEventListener('click', function () {
            currentSort = col.key;
            writePref(SORT_KEY, col.key);
            rerender();
          });
        }
        header.appendChild(cell);
      });
      return header;
    }

    /* ── Rows ── */
    function buildRows() {
      const sorted = sortItems(items);
      const frag = document.createDocumentFragment();
      sorted.forEach(function (item) {
        const row = document.createElement('div');
        row.className = 'finder-list-row';
        row.dataset.itemId = item.id;
        if (item.disabled) row.style.opacity = '0.5';

        const kindLabel = item.kind === 'folder' ? 'folder' : (item.disabled ? 'coming soon' : 'App');
        const sizeLabel = item.sizeLabel || (item.size ? (item.size >= 1024 ? (item.size / 1024).toFixed(1) + ' M' : item.size + ' K') : (item.kind === 'folder' ? '--' : ''));
        const iconHTML  = item.kind === 'folder' ? folderIcon(32) : appIcon(item, 32);

        /* Kit "Atom / Folder tag": a 12px disclosure chevron sits before the
           icon. Files get an empty one so every name still lines up. */
        var chevHTML = '<div class="finder-lr-chev' +
          (item.kind === 'folder' ? ' is-folder' : '') + '"></div>';

        row.innerHTML =
          chevHTML +
          '<div class="finder-lr-icon">' + iconHTML + '</div>' +
          '<div class="finder-lr-name">' + item.label + '</div>' +
          '<div class="finder-lr-size">' + sizeLabel + '</div>' +
          '<div class="finder-lr-kind">' + kindLabel + '</div>' +
          '<div class="finder-lr-pad"></div>';

        frag.appendChild(row);
      });
      return frag;
    }

    function rerender() {
      /* Rebuild header (sort indicator changes) and rows */
      list.innerHTML = '';
      list.appendChild(makeHeader(rerender));
      const body = document.createElement('div');
      body.className = 'finder-list-body';
      body.appendChild(buildRows());
      list.appendChild(body);
    }

    rerender();

    /* ── Interaction ── */
    list.addEventListener('click', function (e) {
      const row = e.target.closest('.finder-list-row');
      list.querySelectorAll('.finder-list-row').forEach(function (r) { r.classList.remove('is-selected'); });
      if (row) { row.classList.add('is-selected'); selectedId = row.dataset.itemId; }
      else selectedId = null;
    });

    list.addEventListener('dblclick', function (e) {
      const row = e.target.closest('.finder-list-row');
      if (!row) return;
      const data = items.find(function (i) { return i.id === row.dataset.itemId; });
      if (data && !data.disabled) onOpen(data);
    });

    /* Mobile: single tap opens (matches icon-view behaviour) */
    list.addEventListener('touchend', function (e) {
      const row = e.target.closest('.finder-list-row');
      if (!row) return;
      e.preventDefault();
      const data = items.find(function (i) { return i.id === row.dataset.itemId; });
      if (data && !data.disabled) onOpen(data);
    });

    container.appendChild(list);
    return list;
  }

  /* ── Render content ── */
  function renderContent(items, scrollEl, onOpen) {
    if (currentView === 'icon') {
      renderIconView(items, scrollEl, onOpen);
    } else {
      renderListView(items, scrollEl, onOpen);
    }
  }

  /* ── Open item action ── */
  function openItem(item) {
    if (item.disabled) return;
    if (item.action === 'collection' && window.OS9Windows) {
      window.OS9Windows.openCollection({ handle: item.handle, title: item.title });
    } else if (item.action === 'portfolio') {
      openPortfolio();
    } else if (item.action === 'snake') {
      if (window.OS9Apps) window.OS9Apps.openSnake();
    } else if (item.action === 'sniper') {
      if (window.OS9Apps) window.OS9Apps.openSniperAssassin();
    } else if (item.action === 'minesweeper') {
      if (window.OS9Apps) window.OS9Apps.openMinesweeper();
    } else if (item.action === 'photoshoop') {
      if (window.AppPhotoshoop) window.AppPhotoshoop.open();
    } else if (item.action === 'budcalc') {
      if (window.OS9Apps) window.OS9Apps.openBudCalc();
    } else if (item.action === 'flash') {
      if (window.OS9Apps && item.swfUrl) {
        window.OS9Apps.openFlashGame({ gameId: item.id, title: item.label, swfUrl: item.swfUrl, aspect: item.aspect });
      }
    } else if (item.action === 'emulator') {
      if (window.AppEmulator) window.AppEmulator.open();
    } else if (item.action === 'games') {
      openGames();
    } else if (item.action === 'memes') {
      openMemes();
    } else if (item.action === 'browser') {
      if (window.OS9Browser) window.OS9Browser.open();
    }
  }

  /* ── Meme detail window ── */
  function openMemeDetail(product, imgSrc) {
    if (!window.OS9Windows) return;
    const desktop = document.getElementById('os9-desktop-area') || document.body;
    const b  = window.OS9Windows ? window.OS9Windows.getDesktopBounds() : { top: 22, left: 0, width: window.innerWidth - 96, height: window.innerHeight - 46 };
    const dw = b.width;
    const dh = b.height;
    const w = 340;
    const h = 420;

    const id = 'meme-detail-' + Date.now();
    const el = window.OS9Windows._buildWindow({
      id, title: product.title,
      width: w, height: h,
      x: Math.max(10, Math.min((dw - w) / 2 + 20, dw - w - 10)),
      y: Math.max(b.top, Math.min((dh - h) / 3 + b.top, dh - h - 10 + b.top))
    });
    desktop.appendChild(el);
    window.OS9Windows._initWindow(el, id);

    const body = el.querySelector('[data-body]');
    body.style.padding = '0';

    const price = product.variants && product.variants[0]
      ? '$' + parseFloat(product.variants[0].price).toFixed(2)
      : '';
    const productUrl = '/products/' + product.handle;
    const btnId = 'meme-view-' + id;

    body.innerHTML = `
      <div style="background:var(--os9-gray-300);padding:16px;display:flex;flex-direction:column;align-items:center;gap:12px;min-height:100%;box-sizing:border-box;font-family: var(--os9-font-body);font-size:var(--os9-size-title);">
        <div style="border:2px inset var(--os9-gray-500);background:var(--os9-white);padding:4px;display:flex;align-items:center;justify-content:center;width:200px;height:200px;flex-shrink:0;">
          <img src="${imgSrc}" alt="${product.title}" style="max-width:192px;max-height:192px;object-fit:contain;display:block;">
        </div>
        <div style="width:100%;">
          <div style="display:flex;gap:8px;padding:5px 0;border-bottom:1px solid var(--os9-gray-500);">
            <span style="font-weight:bold;width:48px;flex-shrink:0;">Title:</span>
            <span style="font-weight:bold;font-size:13px;">${product.title}</span>
          </div>
          <div style="display:flex;gap:8px;padding:5px 0;">
            <span style="font-weight:bold;width:48px;flex-shrink:0;">Price:</span>
            <span>${price}</span>
          </div>
        </div>
        <button id="${btnId}" style="height:26px;min-width:120px;background:linear-gradient(to bottom,var(--os9-azul-mid),var(--os9-azul-mid));border:1px solid var(--os9-azul-dark);border-radius:4px;font-family:var(--os9-font-ui);font-size:var(--os9-size-ui);font-weight:bold;color:var(--os9-white);cursor:default;padding:0 14px;margin-top:auto;">View Product</button>
      </div>
    `;

    body.querySelector('#' + btnId).addEventListener('click', () => {
      if (window.OS9Browser && window.OS9Browser.navigate) {
        window.OS9Browser.navigate(productUrl);
      } else {
        window.open(productUrl, '_blank');
      }
    });
  }

  /* ── Portfolio folder — Storefront API metaobjects viewer ── */
  async function openPortfolio() {
    if (!window.OS9Windows) return;
    const desktop = document.getElementById('os9-desktop-area') || document.body;
    const b  = window.OS9Windows ? window.OS9Windows.getDesktopBounds() : { top: 22, left: 0, width: window.innerWidth - 96, height: window.innerHeight - 46 };
    const dw = b.width;
    const dh = b.height;
    const w = Math.min(500, dw - 20);
    const h = Math.min(480, dh - 40);

    const id = 'finder-portfolio-' + Date.now();
    const el = window.OS9Windows._buildWindow({
      id, title: 'Client Work',
      width: w, height: h,
      x: Math.max(10, (dw - w) / 2),
      y: Math.max(b.top, (dh - h) / 3 + b.top)
    });
    el.classList.add('finder-win');
    desktop.appendChild(el);
    window.OS9Windows._initWindow(el, id);

    const body = el.querySelector('[data-body]');
    const infobar = el.querySelector('[data-infobar]');
    body.innerHTML = '<div style="padding:24px;text-align:center;color:var(--os9-gray-600);font-size:var(--os9-size-title);">Loading portfolio...</div>';

    const token = window.SQUICHE_STOREFRONT_TOKEN;
    if (!token) {
      body.innerHTML = '<div style="padding:24px;text-align:center;color:var(--os9-gray-600);font-size:var(--os9-size-title);">Portfolio unavailable.<br><small>Storefront token not configured.<br>Set window.SQUICHE_STOREFRONT_TOKEN in theme Liquid.</small></div>';
      return;
    }

    try {
      const query = `{
        metaobjects(type: "portfolio_image", first: 50) {
          edges {
            node {
              fields {
                key
                value
                reference {
                  ... on MediaImage {
                    image { url }
                  }
                }
              }
            }
          }
        }
      }`;

      const res = await fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({ query }),
      });
      const json = await res.json();
      const edges = json?.data?.metaobjects?.edges || [];

      infobar.textContent = edges.length + ' items';

      if (!edges.length) {
        body.innerHTML = '<div style="padding:24px;text-align:center;color:var(--os9-gray-600);font-size:var(--os9-size-title);">No portfolio items found.<br><small>Add metaobjects of type "portfolio_image" in Shopify admin.</small></div>';
        return;
      }

      const grid = document.createElement('div');
      grid.className = 'finder-meme-grid';

      edges.forEach(({ node }) => {
        const fields = node.fields;
        const titleField = fields.find(f => f.key === 'title');
        const imageField = fields.find(f => f.key === 'image');
        const title = titleField?.value || 'Untitled';
        const imgUrl = imageField?.reference?.image?.url || null;
        if (!imgUrl) return;

        const item = document.createElement('div');
        item.className = 'finder-meme-item';
        item.innerHTML = `<img src="${imgUrl}?width=72" alt="${title}"><div class="finder-meme-item__label">${title}</div>`;

        const openLightbox = () => {
          const overlay = document.createElement('div');
          overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.9);z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;cursor:zoom-out;';
          const big = document.createElement('img');
          big.src = imgUrl;
          big.style.cssText = 'max-width:90vw;max-height:80vh;object-fit:contain;';
          const label = document.createElement('div');
          label.style.cssText = 'color:var(--os9-white);font-family: var(--os9-font-body);font-size:13px;';
          label.textContent = title;
          overlay.appendChild(big);
          overlay.appendChild(label);
          overlay.onclick = () => overlay.remove();
          document.body.appendChild(overlay);
        };

        const lastTap = {};
        item.addEventListener('dblclick', e => { e.preventDefault(); openLightbox(); });
        item.addEventListener('touchend', e => { e.preventDefault(); openLightbox(); });
        grid.appendChild(item);
      });

      body.innerHTML = '';
      body.appendChild(grid);

    } catch (err) {
      console.error('[Portfolio]', err);
      body.innerHTML = '<div style="padding:24px;text-align:center;color:var(--os9-gray-600);">Could not load portfolio.</div>';
    }
  }

  /* ── Memes folder ── */
  async function openMemes() {
    if (!window.OS9Windows) return;
    const desktop = document.getElementById('os9-desktop-area') || document.body;
    const b  = window.OS9Windows ? window.OS9Windows.getDesktopBounds() : { top: 22, left: 0, width: window.innerWidth - 96, height: window.innerHeight - 46 };
    const dw = b.width;
    const dh = b.height;
    const w = Math.min(500, dw - 20);
    const h = Math.min(480, dh - 40);

    const id = 'finder-memes-' + Date.now();
    const el = window.OS9Windows._buildWindow({ id, title: 'Memes', width: w, height: h,
      x: Math.max(10, (dw - w) / 2), y: Math.max(b.top, (dh - h) / 3 + b.top) });
    el.classList.add('finder-win');
    desktop.appendChild(el);
    window.OS9Windows._initWindow(el, id);

    const body = el.querySelector('[data-body]');
    const infobar = el.querySelector('[data-infobar]');
    body.innerHTML = '<div style="padding:24px;text-align:center;color:var(--os9-gray-600);font-size:var(--os9-size-title);">Loading memes...</div>';

    try {
      const res = await fetch('/collections/memes/products.json?limit=50');
      const data = await res.json();
      const products = data.products || [];

      infobar.textContent = products.length + ' items';

      if (!products.length) {
        body.innerHTML = '<div style="padding:24px;text-align:center;color:var(--os9-gray-600);font-size:var(--os9-size-title);">No memes found.<br>Upload products to the "memes" collection.</div>';
        return;
      }

      const grid = document.createElement('div');
      grid.className = 'finder-meme-grid';
      const lastTap = {};

      products.forEach(p => {
        const imgSrc = p.featured_image
          ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src)
          : null;
        if (!imgSrc) return;
        const item = document.createElement('div');
        item.className = 'finder-meme-item';
        item.innerHTML = `<img src="${imgSrc}?width=72" alt="${p.title}"><div class="finder-meme-item__label">${p.title}</div>`;

        // Single click = select
        item.addEventListener('click', () => {
          grid.querySelectorAll('.finder-meme-item').forEach(i => i.classList.remove('is-selected'));
          item.classList.add('is-selected');
        });

        // Double-click on desktop, single tap on mobile
        item.addEventListener('dblclick', e => {
          e.preventDefault();
          openMemeDetail(p, imgSrc);
        });
        item.addEventListener('touchend', e => {
          e.preventDefault();
          openMemeDetail(p, imgSrc);
        });

        grid.appendChild(item);
      });

      body.innerHTML = '';
      body.appendChild(grid);

    } catch(err) {
      body.innerHTML = '<div style="padding:24px;text-align:center;color:var(--os9-gray-600);">Could not load memes.</div>';
    }
  }

  /* ── Games folder window ── */
  function openGames() {
    if (!window.OS9Windows) return;
    injectCSS();
    currentView = 'icon'; // icon view — single tap works reliably on mobile

    const desktop = document.getElementById('os9-desktop-area') || document.body;
    const b  = window.OS9Windows ? window.OS9Windows.getDesktopBounds() : { top: 22, left: 0, width: window.innerWidth - 96, height: window.innerHeight - 46 };
    const dw = b.width;
    const dh = b.height;
    const w = Math.min(380, dw - 20);
    const h = Math.min(360, dh - 40);

    const id = 'finder-games';
    if (document.getElementById(id)) {
      window.OS9Windows.focusWindow(document.getElementById(id));
      return;
    }
    const el = window.OS9Windows._buildWindow({
      id, title: 'Games', width: w, height: h,
      x: Math.max(10, (dw - w) / 2),
      y: Math.max(b.top, (dh - h) / 3 + b.top)
    });
    el.classList.add('finder-win');
    desktop.appendChild(el);
    window.OS9Windows._initWindow(el, id);

    const scrollEl = el.querySelector('[data-body]');
    const infobar = el.querySelector('[data-infobar]');
    infobar.textContent = GAMES_ITEMS.length + ' items';

    renderContent(GAMES_ITEMS, scrollEl, openItem);

    scrollEl.addEventListener('contextmenu', e => {
      e.preventDefault();
      showCtxMenu(e.clientX, e.clientY,
        () => renderContent(GAMES_ITEMS, scrollEl, openItem),
        () => renderContent(GAMES_ITEMS, scrollEl, openItem)
      );
    });

    let longPressTimer;
    scrollEl.addEventListener('touchstart', e => {
      longPressTimer = setTimeout(() => {
        const touch = e.touches[0];
        showCtxMenu(touch.clientX, touch.clientY,
          () => renderContent(GAMES_ITEMS, scrollEl, openItem),
          () => renderContent(GAMES_ITEMS, scrollEl, openItem)
        );
      }, 600);
    }, { passive: true });
    scrollEl.addEventListener('touchend', () => clearTimeout(longPressTimer));
    scrollEl.addEventListener('touchmove', () => clearTimeout(longPressTimer));
  }

  /* ── Open Squiche HD Finder window ── */
  function openFinderWindow() {
    if (!window.OS9Windows) { setTimeout(openFinderWindow, 200); return; }
    injectCSS();

    const desktop = document.getElementById('os9-desktop-area') || document.body;
    const dw = desktop.offsetWidth || window.innerWidth - 96;
    const dh = desktop.offsetHeight || window.innerHeight - 48;
    const w = Math.min(520, dw - 20);
    const h = Math.min(420, dh - 40);

    const id = 'finder-squiche-hd';
    // Don't open twice — bring existing window to front
    if (document.getElementById(id)) {
      window.OS9Windows.focusWindow(document.getElementById(id));
      return;
    }

    const el = window.OS9Windows._buildWindow({
      id, title: 'Squiche HD', width: w, height: h,
      x: Math.max(10, (dw - w) / 2),
      y: Math.max(10, (dh - h) / 3)
    });
    el.classList.add('finder-win');
    desktop.appendChild(el);
    window.OS9Windows._initWindow(el, id);

    const scrollEl = el.querySelector('[data-body]');
    const infobar = el.querySelector('[data-infobar]');
    infobar.textContent = '3 items, 2.11 GB available';

    // Render initial view
    renderContent(SQUICHE_HD_ITEMS, scrollEl, openItem);

    // Right-click context menu
    scrollEl.addEventListener('contextmenu', e => {
      e.preventDefault();
      showCtxMenu(e.clientX, e.clientY,
        () => renderContent(SQUICHE_HD_ITEMS, scrollEl, openItem),
        () => renderContent(SQUICHE_HD_ITEMS, scrollEl, openItem)
      );
    });

    // Long-press on mobile = context menu
    let longPressTimer;
    scrollEl.addEventListener('touchstart', e => {
      longPressTimer = setTimeout(() => {
        const touch = e.touches[0];
        showCtxMenu(touch.clientX, touch.clientY,
          () => renderContent(SQUICHE_HD_ITEMS, scrollEl, openItem),
          () => renderContent(SQUICHE_HD_ITEMS, scrollEl, openItem)
        );
      }, 600);
    }, { passive: true });
    scrollEl.addEventListener('touchend', () => clearTimeout(longPressTimer));
    scrollEl.addEventListener('touchmove', () => clearTimeout(longPressTimer));
  }

  /* ── Expose public API ── */
  window.OS9Finder = {
    /* Squiche HD, the Cart and Trash all open ONE window — the shared shop
       window in os9-windows.js. This just asks for it rooted at the Finder.
       openFinderWindow() is kept as a fallback for when os9-windows.js has
       not finished loading. */
    open: function () {
      if (window.OS9Windows && window.OS9Windows.openFinder) window.OS9Windows.openFinder({});
      else openFinderWindow();
    },
    /* Renderer + data, so the shared window can host the Finder as a frame.
       Also wires the right-click / long-press menu, so view and sort still
       work now that the Finder renders inside the shared shop window. */
    renderInto: function (el, items, onOpen) {
      injectCSS();
      var list = items || SQUICHE_HD_ITEMS;
      var open = onOpen || openItem;
      var self = this;
      function paint() { renderContent(list, el, open); wire(); }
      function wire() {
        if (el.dataset.finderMenuWired) return;
        el.dataset.finderMenuWired = '1';
        el.addEventListener('contextmenu', function (e) {
          e.preventDefault();
          showCtxMenu(e.clientX, e.clientY, paint, paint);
        });
        var timer;
        el.addEventListener('touchstart', function (e) {
          timer = setTimeout(function () {
            var t = e.touches[0];
            showCtxMenu(t.clientX, t.clientY, paint, paint);
          }, 600);
        }, { passive: true });
        el.addEventListener('touchend',  function () { clearTimeout(timer); });
        el.addEventListener('touchmove', function () { clearTimeout(timer); });
      }
      paint();
    },
    rootItems: function () { return SQUICHE_HD_ITEMS.slice(); },
    /* The Finder root expands Games inline, so it needs the same list the
       Games window renders — one definition, two presentations. */
    gamesItems: function () { return GAMES_ITEMS.slice(); },
    appIcon:    appIcon,
    openItem:  openItem,
    injectCSS: injectCSS,
    openGames: openGames,
    openGameById: function (id) {
      var item = GAMES_ITEMS.filter(function (g) { return g.id === id; })[0];
      if (item) openItem(item);
    },
  };

  /* ── Patch OS9Windows to expose _buildWindow and _initWindow ── */
  // We need these so the Finder can create OS9-style windows
  // They get set when os9-windows.js loads
  function waitForWindows() {
    if (window.OS9Windows && window.OS9Windows._buildWindow) return;
    setTimeout(waitForWindows, 100);
  }
  waitForWindows();

})();